import type { ReactElement } from 'react'
import { NavLink } from 'react-router-dom'
import { DropdownMenu } from '../../../components/DropdownMenu'
import type { NavigationProps } from './types'

export function DesktopNavigation({
  items,
  openDropdowns,
  toggleDropdown,
}: NavigationProps): ReactElement {
  return (
    <nav className="hidden items-center sm:flex">
      <ul className="flex items-center gap-1.5">
        {items.map((item) => (
          <li key={item.label} className={item.subItems ? 'relative' : ''}>
            {item.href ? (
              item.href.startsWith('http') ? (
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center rounded-xl px-3.5 py-1.5 font-medium text-gray-600 text-sm transition-all hover:bg-gray-100/80 hover:text-gray-900"
                >
                  {item.label}
                </a>
              ) : (
                <NavLink
                  to={item.href}
                  className={({ isActive }) =>
                    `inline-flex items-center rounded-xl px-3.5 py-1.5 font-medium text-sm transition-all ${
                      isActive
                        ? 'bg-indigo-50 font-semibold text-indigo-700 shadow-xs'
                        : 'text-gray-600 hover:bg-gray-100/80 hover:text-gray-900'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              )
            ) : item.onClick ? (
              <button
                type="button"
                onClick={item.onClick}
                className="inline-flex items-center rounded-xl px-3.5 py-1.5 font-medium text-gray-600 text-sm transition-all hover:bg-gray-100/80 hover:text-gray-900"
              >
                {item.label}
              </button>
            ) : (
              <DropdownMenu
                item={item}
                isOpen={openDropdowns[item.label]}
                toggleDropdown={toggleDropdown}
              />
            )}
          </li>
        ))}
      </ul>
    </nav>
  )
}
